import { render, staticRenderFns } from "./SpaceSwitcher.vue?vue&type=template&id=abefd994&scoped=true"
import script from "./SpaceSwitcher.vue?vue&type=script&lang=js"
export * from "./SpaceSwitcher.vue?vue&type=script&lang=js"
import style0 from "./SpaceSwitcher.vue?vue&type=style&index=0&id=abefd994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abefd994",
  null
  
)

export default component.exports